import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { lastValueFrom, BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AppidService {

    // Called by each component to know the appID
    // BehaviorSubject to store the current appID and allow other components to subscribe to changes
    private appIDSubject = new BehaviorSubject<number | null>(null);

    // Observable to expose the appID so that other components can react to its updates.
    appID$ = this.appIDSubject.asObservable();
    appName;
    GUIthemeID;
    appLogo;
    displayDownloadIconsInApp;
    public roles = null;

    constructor(private route: Router, private http: HttpClient) {}

    /**
     * Fetches the app ID based on the current hostname.
     * Makes an HTTP POST request to retrieve the app ID from the backend.
     * If the request fails, it falls back to a default app ID.
     * 
     * @returns A Promise that resolves to the app ID.
     */
    async getAppID(): Promise<number | null> {
        const url = window.location.hostname;
        try {
            const response = await lastValueFrom(this.http.post<any>(environment.urls.core + "/auth/getappid", { url }));
            this.appName = response.AppName;
            this.appIDSubject.next(response?.ID);
            this.appName = response.AppName;
            this.GUIthemeID = response.GUI_ThemeID;
            this.appLogo = response.AppLogo;
            this.displayDownloadIconsInApp = response.DisplayDownloadIcons;
            return response?.ID;
        } catch (error) {
            console.error("Error fetching appID:", error);
            return null;
        }
    }

    /**
     * Returns a set of roles based on the app ID.
     * 
     * @param appID - The app ID for which roles are needed.
     * @returns An object mapping role IDs to their corresponding names.
     */
    getRoles(appID) {
        if (appID == 434693) {
            return {
                '97': 'Venue',
                '98': 'Performer'
            };
        } else if (appID == 795418) {
            return {
                '269': 'Staff',
                '270': 'Parent'
            };
        } else {
            return null;
        }
    }
}
